import { notification } from "antd"
import { Scrollbars } from "react-custom-scrollbars-2"

const infoNotice = (title, description = "", duration = null) => {
	notification["info"]({
		description: (
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 300 }
			>
				<span>
					{ description }
				</span>
			</Scrollbars>
		),
		duration  : duration,
		message   : title,
		placement : "bottomLeft"
	})
}

const successNotice = (title, description = "", duration = null) => {
	return notification["success"]({
		description: (
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 300 }
			>
				<span>
					{ description }
				</span>
			</Scrollbars>
		),
		duration  : duration === null ? 5 : duration,
		message   : title,
		placement : "bottomLeft"
	})
}

const warningNotice = (title, description = "", duration = null) => {
	notification["warning"]({
		description: (
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 300 }
			>
				<span>
					{ description }
				</span>
			</Scrollbars>
		),
		duration  : duration,
		message   : title,
		placement : "bottomLeft"
	})
}

const errorNotice = (title, description = "", duration = null) => {
	notification["error"]({
		description: (
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 300 }
			>
				<span>
					{ description }
				</span>
			</Scrollbars>
		),
		duration  : duration,
		message   : title,
		placement : "bottomLeft"
	})
}

const notifications = {
	errorNotice,
	infoNotice,
	successNotice,
	warningNotice
}

export default notifications
